module.exports = function() {
  return new Worker(__webpack_public_path__ + "e986c762b393ca93197e.worker.js");
};